// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from '@stencil/core'
import { Component, Element, h } from '@stencil/core'

import type { Attributes } from '../../helpers'
import { inheritAriaAttributes } from '../../helpers'

/**
 * The `<qds-table-head>` element encapsulates a set of rows (`<qds-table-row>`
 * elements) indicating that they comprise the head of the table
 * (`<qds-table>`).
 *
 * @see https://quartz.se.com/build/components/table
 */
@Component({
  tag: 'qds-table-head',
  shadow: true,
  styleUrl: 'table-head.css',
})
export class TableHead implements ComponentInterface {
  @Element() private readonly host!: HTMLElement

  #inheritedAttributes: Attributes = {}

  public componentWillLoad(): void {
    this.#inheritedAttributes = inheritAriaAttributes(this.host)
  }

  public render() {
    return (
      <thead
        class="qds-table-head"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.#inheritedAttributes}
      >
        <slot />
      </thead>
    )
  }
}
